"use strict";
/*jshint esversion: 11 */

import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {getTodayLongDate} from "../utils/utils";
import CsfMembreUtils from "../utils/CsfMembreUtils";

export default function CsfMembreHistoryPrint({ member,
                                                activities,
                                                periodTitle,
                                                periodSubTitle = '',
                                                memberName,
                                                certificatNumber,
                                                tableId
                                              }) {

  const language = document.documentElement.lang;

  return (
    <div className="print-wrapper">
      <div className="print-page">
        <div className="print-header">
          <img src="/themes/custom/tink/dist/assets/print-black-logo.png"
                alt="Chambre de la sécurité financière"/>
          <h1>
            {window.Drupal.t('membre.print.summary.headline1')} {window.Drupal.t('membre.heading.cert')} {certificatNumber}
          </h1>
          <p>
            {window.Drupal.t('fournisseur.print.p1.section1.header.submitted')} {getTodayLongDate(document.documentElement.lang)}
            {' ' + window.Drupal.t('fournisseur.print.p1.section1.header.by')} {memberName}
          </p>
        </div>

        <div className="print-section">
          <h2>{window.Drupal.t('membre.activities.title')}</h2>
          <p>{periodTitle} ({periodSubTitle})</p>
          <div className="inner-wrapper">
            <div className="table-wrapper">
              <table className="activities__table">
                <thead>
                <tr>
                  <th>
                    {window.Drupal.t('fournisseur.activities-list.table.number')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.activities.activityTitle')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.activities.attendanceDate')}
                  </th>
                  <th>
                    {window.Drupal.t('PDU')}
                  </th>
                </tr>
                </thead>
                <tbody>
                  {[...new Map(activities.map(item => [item.Activite_Id, item])).values()].map((item, index) => (
                    <Fragment key={`${item.Activite_Id}-print-${index}-${tableId}`}>
                      <tr className="activities__base-info">
                        <td>
                          {item?.Recognition_Code}
                        </td>
                        <td>
                          {item?.Activite_Id__Rn_Descriptor}
                        </td>
                        <td>
                          {CsfMembreUtils.getFormattedDate(item?.Suivi_Le)}
                        </td>
                        <td>
                          <div className="d-flex align-items-center justify-content-between">
                            {item?.SousTotal}&nbsp;{window.Drupal.t('PDU')}
                          </div>
                        </td>
                      </tr>
                      <tr className="activities__more-info">
                        <td colSpan="4" className="p-0">
                          <div className="px-2">
                            <div className="d-flex align-items-center">
                              { item?.IsCurrentUserTrainer && (
                                <p className="m-0 ml-auto">{window.Drupal.t('membre.activities.isTrainer')}</p>
                              )}
                            </div>
                            <div className="activities__tag-list d-flex flex-wrap flex-md-no-wrap">
                              {
                                Object.entries(item?.activityCourses)?.filter(([key]) => !key.toLowerCase().includes("gsft"))?.map(([key, value], index) => (
                                  <span key={`${item.Activite_Id}-tag-${index}-print-${tableId}`} className="activities__tag">
                                    <span>{key}</span>
                                    <span>{value ? `+ ${value} ${window.Drupal.t('PDU')}` : window.Drupal.t('membre.tag.na')}</span>
                                  </span>
                                ))
                              }
                            </div>
                          </div>
                        </td>
                      </tr>
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CsfMembreHistoryPrint.propTypes = {
  member: PropTypes.object,
  activities: PropTypes.array.isRequired,
  periodTitle: PropTypes.string,
  periodSubTitle: PropTypes.string,
  memberName: PropTypes.string,
  certificatNumber: PropTypes.string,
  tableId: PropTypes.string
};

